import { isArray, joinStringsWithSpaces } from '@/plugins/helper'
import { isElementPureText } from '@/utils/helpers/processHtml/prettifyHtml'

export function addClassToParentElements(elements, className) {
  if (!isArray(elements)) {
    return elements
  }

  return elements.map(el => {
    if (isElementPureText(el)) {
      return el
    }

    const attrClass = (el.attrs && el.attrs.class) || ''
    const mergedClass = joinStringsWithSpaces([attrClass, className])

    return {
      ...el,
      attrs: {
        ...el.attrs,
        class: mergedClass
      }
    }
  })
}
